import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tempPolicySlice:{
    policyCategory: 'retail',
    staff_Id: '',
    branchCode: '',
    customerCode: '',
    branchName: '',
    customerMobile: '',
    customerEmail: '',
    customerName: '',
    customerGroupName: '',
    subCustomerGroupName: '',
    insurerName: '',
    title: '',
    nomineeName: '',
    relationWithNominee: '',
    policytype: '',
    product: '',
    gstNumber: '',
    subProduct: '',
    insuranceCompany: '',
    brokerName: 'JP INSURANCE BROKER',
    brokerBranch: '',
    yearOfRenewal: '',
    policyDurationInDays: '',
    policyDuration: '',
    startDate: '',
    endDate: '',
    noOfdays: '',
    isRenewable: '',

    policyPerticulars: '',
    riskCode: '',
    netPremium: 0,
    coverageTP: 0,
    sumInsured: 0,
    odPremium: 0,

    tpPolicyDuration: '',
    tpStartDate: '',
    tpEndDate: '',

    sgst: 0,
    cgst: 0,
    igst: 0,
    ugst: 0,
    totalAmount: '0',
    modeOfPayment: '',
    amount: '',
    DateOfPayment: '',
    transactionId: '',
    transactionDate: '',

    POS_MIS_REF: '',
    bpqCode: '',
    brokerageRate: 0,

    odBrokerageRate: 0,
    odBrokerageAmount: 0,
    tpBrokerageRate: 0,
    tpBrokerageAmount: 0,
    brokerageRateOnOtherTerrorism: 0,
    brokerageAmountOnOtherTerrorism: 0,
    brokerageRateOnTerrorism: 0,
    brokerageAmountOnTerrorism: 0,
    totalBrokerageAmount: 0,
    totalBrokerageGstPer: 0,
    totalBrokerageAmountIncGst: 0,

    // for endorsementr
    endorsementBrokerageRateOnOtherTerrorism: 0,
    endorsementBrokerageAmountOnOtherTerrorism: 0,
    endorsementBrokerageRateOnTerrorism: 0,
    endorsementBrokerageAmountOnTerrorism: 0,
    endorsementOdBrokerageRate: 0,
    endorsementOdBrokerageAmount: 0,
    endorsementTpBrokerageRate: 0,
    endorsementTpBrokerageAmount: 0,
    endorsementTotalBrokerageAmount: 0,
    endorsementTotalBrokerageGstPer: 0,
    endorsementTotalBrokerageAmountIncGst: 0,

    co_brokerageName: '',
    co_brokerageBranchCode: '',
    co_brokerageShare: '',

    //details

    vehicalMake: '',
    vehicleModel: '',
    vehicalSubModel: '',
    vehicleNo: '',
    engineNo: '',
    month_Year_of_regn: '',
    fuelType: '',
    yearOfManufacture: '',
    seatingCapacity: '',
    chassisNo: '',

    //fire flields
    terrorism: '',
    otherTerrorism: '',
    otherAddon: [],
    locationOfPropertyInsured: '',

    // endorsement fields

    endorsementName: '',
    endorsementReason: '',
    endorsementPolicyNo: '',
    endorsementStartDate: '',
    endorsementEndDate: '',
    endorsementTerrorism: '',
    endorsementOtherTerrorism: '',
    endorsementNetPremium: 0,
    endorsementSGST: 0,
    endorsementCGST: 0,
    endorsementIGST: 0,
    endorsementUGST: 0,
    endorsementTotalAmount: 0,

    // other field

    // enginering
    locationOfProjectSite: '',
    // engineering and health
    nextInstallmentDueDate: '',
    noOfPremiumInstallment: '',

    // only health
    noOflivesCover: '',

    // only liablity
    occupation: '',
    retroActiveDate: '',

    // for marine and misllaneous
    incoterms: '',
    marineCargoClause: '',
  },
};

const tempPolicySlice = createSlice({
    name: 'policyData',
    initialState,
    reducers: {
        setTempPolicyData: (state, action) => {
            state.tempPolicyData = action.payload;
        },
        clearTempPolicyData: (state) => {
            // const confirmation = window.confirm('Are you sure you want to clear the form ?');
            // if (confirmation) {
                state.tempPolicyData = {}; 
            // }        
        },
        updateTempPolicyData: (state, action) => {
            const { key, value } = action.payload;
            state.tempPolicyData[key] = value;
        },
        
    },
});

export const { setTempPolicyData, clearTempPolicyData } = tempPolicySlice.actions;

export default tempPolicySlice.reducer;
